/**
 * RBAC V2 — Helpers centralisés pour les comparaisons de rôles côté frontend.
 *
 * Reflète `/app/backend/middleware/rbac.py`. À utiliser PARTOUT au lieu de
 * comparaisons hard-codées (`role === 'operateur'`).
 *
 * Quand la matrice de rôles évolue, mettez à jour ces deux fichiers en miroir.
 */

// Listes (mêmes valeurs que côté backend)
export const OPS_ROLES = ['admin', 'lead_ops', 'ops', 'operateur'];
export const FIELD_OPS_ROLES = ['admin', 'lead_field_ops', 'field_ops'];
export const COMMERCIAL_ROLES = ['admin', 'lead_commercial', 'commercial'];
export const FINANCE_ROLES = ['admin', 'finance', 'auditeur'];
export const INTERNAL_STAFF_ROLES = Array.from(new Set([
  ...OPS_ROLES, ...FIELD_OPS_ROLES, ...COMMERCIAL_ROLES, ...FINANCE_ROLES, 'super_admin',
]));
export const OPERATIONAL_ROLES = Array.from(new Set([...OPS_ROLES, ...FIELD_OPS_ROLES]));

const norm = (r) => {
  if (!r) return '';
  if (typeof r === 'object') r = r.role || '';
  return String(r).toLowerCase().trim();
};

export const isAdmin = (r) => ['admin', 'super_admin'].includes(norm(r));
export const isOpsTeam = (r) => OPS_ROLES.includes(norm(r));
export const isFieldTeam = (r) => FIELD_OPS_ROLES.includes(norm(r));
export const isCommercialTeam = (r) => COMMERCIAL_ROLES.includes(norm(r));
export const isFinanceTeam = (r) => FINANCE_ROLES.includes(norm(r));
export const isOperationalTeam = (r) => OPERATIONAL_ROLES.includes(norm(r));
export const isInternalStaff = (r) => INTERNAL_STAFF_ROLES.includes(norm(r));

// Combinaisons pratiques pour l'UI
export const canEditTransportData = (r) => isOpsTeam(r) || isFieldTeam(r) || isCommercialTeam(r);
export const canBulkAction = (r) => isOpsTeam(r) || isAdmin(r);
export const canExportData = (r) => isAdmin(r) || isOpsTeam(r) || isCommercialTeam(r) || isFinanceTeam(r);

// Helper pratique pour vérifier multi-team via une seule liste
export const hasRoleInAny = (role, listOfLists) => {
  const r = norm(role);
  return listOfLists.some((list) => list.includes(r));
};
